export function hasAnalyticsConsent() {
  if (typeof window === "undefined") {
    return false;
  }

  if (window.Cookiebot && window.Cookiebot.consent) {
    return !!window.Cookiebot.consent.statistics
  }

  return !!window.__analyticsConsentGranted
}
